<template>
  <span>
    <a href="#" @click.prevent="$bvModal.show('create-op-button' + id)"><i class="pr-1 fa fa-lg fa-arrow-right"></i></a>
    <b-modal
      :id="'create-op-button' + id"
      title="Crear/Editar Orden de pedido"
      @ok="onSubmit"
      @show="onShow"
      :ok-disabled="$v.form.$invalid || loading"
    >
      <b-form>
        <b-form-group label="Fecha de entrega" label-for="delivery_date">
          <b-form-datepicker
            id="delivery_date"
            v-model="$v.form.delivery_date.$model"
            :state="$v.form.delivery_date.$dirty ? !$v.form.delivery_date.$error : null"
          ></b-form-datepicker>
        </b-form-group>
        <b-form-group label="Cajas" label-for="quantity">
          <b-form-input
            id="quantity"
            v-model="$v.form.quantity.$model"
            :state="$v.form.quantity.$dirty ? !$v.form.quantity.$error : null"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Kilos"
          label-for="kilograms"
          :description="`No debe pasarse de la totalidad del plan (${maxKilograms}Kg).`"
        >
          <b-form-input id="kilograms" disabled :value="kilograms"></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </span>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "CreatePurchaseOrder",
  props: {
    id: {
      type: Number,
      default: 0
    },
    planId: {
      type: Number
    },
    clientCustomerId: {
      type: Number
    },
    containerId: {
      type: Number
    },
    planData: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        client_customer: null,
        delivery_date: null,
        plan: null,
        container: null,
        status: null,
        quantity: 0
      },
      clientCustomerOptions: [],
      plansOptions: [],
      containerOptions: [],
      maxKilograms: 0,
      container: null
    };
  },
  validations() {
    return {
      form: {
        client_customer: {
          required
        },
        delivery_date: {
          required
        },
        plan: {
          required
        },
        container: {
          required
        },
        status: {
          required
        },
        quantity: {
          required,
          validateMaxKilograms: this.validateMaxKilograms
        }
      }
    };
  },
  computed: {
    kilograms() {
      if (this.container) {
        let num = this.form.quantity * parseFloat(this.container.value.net_weight);
        num = Math.round(num * 100) / 100;
        return num;
      } else {
        return 0;
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        id: null,
        client_customer: null,
        delivery_date: null,
        plan: null,
        container: null,
        status: null,
        kilograms: null
      };
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onShow() {
      this.form.client_customer = this.planData.client_customer;
      this.form.plan = this.planData.id;
      this.form.container = this.planData.container;
      this.form.status = this.planData.status;
      this.maxKilograms = this.planData.kilograms - this.planData.ordered_kilograms;
      this.getContainer().then((data) => {
        this.container = data;
        this.loading = false;
      });
    },
    validateMaxKilograms() {
      if (this.kilograms > this.maxKilograms) {
        console.log("ACAACK!!! 🐔", "te pasaste");
        return false;
      } else {
        return true;
      }
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      const data = {
        id: this.form.id,
        client_customer: this.form.client_customer,
        delivery_date: this.form.delivery_date,
        plan: this.form.plan,
        container: this.form.container,
        status: this.form.status,
        quantity: this.form.quantity,
        kilograms: this.kilograms
      };
      try {
        await this.$axios.post("/api/v1/purchase_order/", data);
        this.$bvModal.hide("create-op-button" + this.id);
        this.$swal("¡Éxito!", "Orden de pedido creada", "success");
        this.$emit("refresh");
      } catch (error) {
        this.$bvToast.toast("Error al crear la orden de pedido", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
      this.loading = false;
      this.resetForm();
    },
    async getContainer() {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/container/${this.planData.container}/`);
        return response.data;
      } catch (error) {
        console.log(error);
        return null;
      }
    }
  }
};
</script>

<style></style>
